var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.33203 8.0013C1.33203 5.48714 1.33203 4.23007 2.11308 3.44902C2.89413 2.66797 4.15121 2.66797 6.66536 2.66797H9.33203C11.8462 2.66797 13.1033 2.66797 13.8843 3.44902C14.6654 4.23007 14.6654 5.48714 14.6654 8.0013V9.33464C14.6654 11.8488 14.6654 13.1059 13.8843 13.8869C13.1033 14.668 11.8462 14.668 9.33203 14.668H6.66536C4.15121 14.668 2.89413 14.668 2.11308 13.8869C1.33203 13.1059 1.33203 11.8488 1.33203 9.33464V8.0013Z",
    stroke: "#29286A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.66797 2.66797V1.66797",
    stroke: "#29286A",
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.332 2.66797V1.66797",
    stroke: "#29286A",
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1.66797 6H14.3346",
    stroke: "#29286A",
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.335 11C11.5188 11.0002 11.6678 11.1492 11.668 11.333C11.668 11.517 11.5189 11.6668 11.335 11.667C11.1509 11.667 11.001 11.5171 11.001 11.333C11.0012 11.1491 11.151 11 11.335 11ZM11.335 8.33301C11.5189 8.33318 11.668 8.48301 11.668 8.66699C11.6678 8.85083 11.5188 8.99982 11.335 9C11.151 9 11.0012 8.85094 11.001 8.66699C11.001 8.4829 11.1509 8.33301 11.335 8.33301Z",
    stroke: "#29286A",
    strokeWidth: 0.666667
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M7.99902 11C8.18286 11.0002 8.33186 11.1492 8.33203 11.333C8.33203 11.517 8.18297 11.6668 7.99902 11.667C7.81493 11.667 7.66504 11.5171 7.66504 11.333C7.66521 11.1491 7.81504 11 7.99902 11ZM7.99902 8.33301C8.18297 8.33318 8.33203 8.48301 8.33203 8.66699C8.33186 8.85083 8.18286 8.99982 7.99902 9C7.81504 9 7.66521 8.85094 7.66504 8.66699C7.66504 8.4829 7.81493 8.33301 7.99902 8.33301Z",
    stroke: "#29286A",
    strokeWidth: 0.666667
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M4.66699 11C4.85083 11.0002 4.99982 11.1492 5 11.333C5 11.517 4.85094 11.6668 4.66699 11.667C4.4829 11.667 4.33301 11.5171 4.33301 11.333C4.33318 11.1491 4.48301 11 4.66699 11ZM4.66699 8.33301C4.85094 8.33318 5 8.48301 5 8.66699C4.99982 8.85083 4.85083 8.99982 4.66699 9C4.48301 9 4.33318 8.85094 4.33301 8.66699C4.33301 8.4829 4.4829 8.33301 4.66699 8.33301Z",
    stroke: "#29286A",
    strokeWidth: 0.666667
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/Calendar.2722abc43071ad1b76c6b6ba400dc85a.svg";
export { ForwardRef as ReactComponent };